import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '@/lib/i18n';
import { ArrowLeft } from '@phosphor-icons/react';

export default function Impressum() {
  const { t } = useI18n();

  useEffect(() => {
    window.scrollTo({ top: 0 });
    document.title = 'Impressum – De Melo Recruiting';
  }, []);

  return (
    <div data-testid="impressum-page" className="bg-white min-h-screen pt-32 pb-24 md:pb-32">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <Link to="/" data-testid="impressum-back" className="inline-flex items-center gap-2 text-[#C5A059] hover:text-[#0A1128] text-[12px] tracking-[0.22em] uppercase font-semibold transition-colors">
          <ArrowLeft size={16} weight="bold" /> {t.legal.back}
        </Link>
        <div className="eyebrow text-[#C5A059] mt-10">{t.legal.imprintEyebrow}</div>
        <h1 className="heading-display mt-4 text-[#0A1128] text-4xl sm:text-5xl">Impressum</h1>
        <div className="mt-3 h-px w-12 bg-[#C5A059]" />

        <div className="mt-12 space-y-10 text-[#1E2229]/85 text-[15px] leading-relaxed">
          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">Angaben gemäß § 5 TMG</h2>
            <p>
              De Melo Recruiting<br/>
              Inh. Thiago Pereira Casanova de Melo<br/>
              Buchenstraße 14<br/>
              79108 Freiburg im Breisgau<br/>
              Deutschland
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">Kontakt</h2>
            <p>
              Telefon: <a href="tel:+4915208483930" className="text-[#C5A059] hover:underline">+49 152 08483930</a><br/>
              E-Mail: <a href="mailto:info@demelo-recruiting.de" className="text-[#C5A059] hover:underline">info@demelo-recruiting.de</a>
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">Vertretungsberechtigter</h2>
            <p>Thiago Pereira Casanova de Melo</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">Umsatzsteuer-ID</h2>
            <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br/>
              <span className="font-medium text-[#0A1128]">DE458723026</span>
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">Eintrag im Handelsregister / Gewerbeanmeldung</h2>
            <p className="text-[#64748B]">[HRB-Nummer oder Gewerbe-Reg.-Nr. einfügen, sofern zutreffend]</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <p>
              Thiago Pereira Casanova de Melo<br/>
              Buchenstraße 14, 79108 Freiburg im Breisgau
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">EU-Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              {' '}<a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#C5A059] hover:underline">https://ec.europa.eu/consumers/odr/</a>.
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">Verbraucher­streit­beilegung / Universal­schlichtungs­stelle</h2>
            <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucher­schlichtungs­stelle teilzunehmen.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">Haftung für Inhalte</h2>
            <p>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">Haftung für Links</h2>
            <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">Urheberrecht</h2>
            <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
          </section>

          <p className="text-[#64748B] text-sm pt-6 border-t border-[#E2E8F0]">
            Die mit <span className="text-[#C5A059]">[…]</span> markierten Felder können bei Bedarf vom Betreiber ergänzt werden (z. B. HRB-Nummer, sofern eine Handelsregister-Eintragung erfolgt).
          </p>
        </div>
      </div>
    </div>
  );
}
